import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  list = {
    home: {
      title: 'Overview',
      url: '/admin/home',
      parents: []
    },
    leaRenewals: {
      title: 'Renewal Users',
      url: '/admin/renewal-users',
      parents: ['home']
    },
    powerBI: {
      title: 'Reports',
      url: '/admin/reports',
      parents: ['home']
    },
    templates: {
      title: 'Templates',
      url: '/admin/templates',
      parents: ['home']
    },
    feedbackReport: {
      title: 'User Feedback',
      url: '/admin/feedback',
      parents: ['home']
    },
    approachProfiles: {
      title: 'Approach Profiles',
      url: '/admin/approach-profiles',
      parents: ['home']
    },
    userGuides: {
      title: 'User Guides',
      url: '/admin/user-guides',
      parents: ['home']
    },
    pdfUserGuides: {
      title: 'PDF User Guides',
      url: '/admin/pdf-user-guides',
      parents: ['home']
    },
    attestations: {
      title: 'Attestations',
      url: '/admin/attestations',
      parents: ['home']
    },
    teachingFields:{
      title: 'Teaching Fields',
      url: '/admin/teaching-fields',
      parents: ['home']
    },
    notificationTemplates:{
      title: 'Notification Templates',
      url: '/admin/notification-templates',
      parents: ['home']
    },
    stipendEligibility:{
      title: 'Stipend Eligibility',
      url: '/admin/stipend-eligibility',
      parents: ['home']
    },
    stipendConfig:{
      title: 'Stipend Configuration',
      url: '/admin/leadership-config',
      parents: ['home']
    }
  }
  breadcrumbs: Array<any> = [];
  constructor() { }

  setBreadcrumb(currentPage: keyof typeof this.list) {
    this.breadcrumbs = [];
    this.list[currentPage].parents.forEach((parentKey: string ) => {
      const key = parentKey as keyof typeof this.list;
      this.breadcrumbs.push(this.list[key]);
    });
    this.breadcrumbs.push(this.list[currentPage]);
  }

}
